import {
    dealRefreshMiddleware,
    isFeatureVisible,
    getDealRefreshAppNameWhitelist,
    getDealXgId,
    isCorrectPhoneHandlingEnabledInState
} from '@makemydeal/dr-sales-checkin-store';
import { SALES_CHECKIN_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { FEATURES } from '@makemydeal/dr-sales-checkin-types';
import { fetchDeal } from '../actions/fetchDeal';

export const dealRefreshModalMiddleware = dealRefreshMiddleware({
    // Callback so Common Consumer is included only when its feature toggle is on (per-dealer,
    // like Manager View); CMD/AMD remain always-whitelisted and edition-gated by `isEnabled` below.
    getAppNameWhitelist: getDealRefreshAppNameWhitelist,
    // Edition gate (F303238) — deal refresh rides the `gtl` capability. `isFeatureVisible` is
    // already `(state) => boolean`, so it drops straight into the config; the deferred-release
    // path is gated separately in dealRefreshDefer/helpers.ts, which dispatches
    // showDealRefreshModal() independently of this middleware.
    isEnabled: isFeatureVisible(FEATURES.GTL),
    onRefresh: (store, meta) => {
        const state = store.getState();
        const dealXgId = getDealXgId(state);
        const enableCorrectPhoneHandling = isCorrectPhoneHandlingEnabledInState(state);
        store.dispatch(fetchDeal(SALES_CHECKIN_APP_PREFIX, dealXgId, { ...meta, enableCorrectPhoneHandling }));
    }
});
